import { Briefcase, Target, Users } from 'lucide-react'

interface Stats {
    users_count: number
    accounts_count: number
    opportunities_count: number
}

interface Props {
    stats: Stats
}

export default function StatsCards({ stats }: Props) {
    return (
        <div className="space-y-4">
            <div className="bg-white shadow rounded-lg p-6">
                <div className="flex items-center">
                    <Users className="h-8 w-8 text-blue-500"/>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-500">Users</p>
                        <p className="text-2xl font-semibold text-gray-900">{stats.users_count}</p>
                    </div>
                </div>
            </div>

            <div className="bg-white shadow rounded-lg p-6">
                <div className="flex items-center">
                    <Briefcase className="h-8 w-8 text-green-500"/>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-500">Accounts</p>
                        <p className="text-2xl font-semibold text-gray-900">{stats.accounts_count}</p>
                    </div>
                </div>
            </div>

            <div className="bg-white shadow rounded-lg p-6">
                <div className="flex items-center">
                    <Target className="h-8 w-8 text-purple-500"/>
                    <div className="ml-4">
                        <p className="text-sm font-medium text-gray-500">Opportunities</p>
                        <p className="text-2xl font-semibold text-gray-900">{stats.opportunities_count}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}